<template>
   <div class="order-search-page-container sub-page-wrapper">
      <Aside />
      <Main>
         <Navbar />
         <div class="container-fluid">
            <div class="row">
               <div class="col gts-box mx-3">
                  <h1 class="sub-page-header">{{ $t("orderSearch_pageTitle") }}</h1>
                  <!-- PRODUCTS -->
                  <div class="sub-page-row-wrapper row gy-3">
                     <div class="col-3 col-md-3 col-lg-1">
                        <UIRadioButton :label="$t('orderSearch_filter_lblFlight')" name="serviceFlight" id="serviceFlight" native-value="1" v-model="product" />
                     </div>
                     <div class="col-3 col-md-3 col-lg-1">
                        <UIRadioButton :label="$t('orderSearch_filter_lblHotel')" name="serviceHotel" id="serviceHotel" native-value="2" v-model="product" />
                     </div>
                     <div class="col-3 col-md-3 col-lg-1">
                        <UIRadioButton :label="$t('orderSearch_filter_lblTransfer')" name="serviceTransfer" id="serviceTransfer" native-value="3" v-model="product" />
                     </div>
                     <div class="col-3 col-md-3 col-lg-1">
                        <UIRadioButton :label="$t('orderSearch_filter_lblRentACar')" name="serviceRentACar" id="serviceRentACar" native-value="4" v-model="product" />
                     </div>
                  </div>

                  <!-- FLIGHT SEARCH -->
                  <div class="sub-page-row-wrapper row gy-3" v-if="product == 1">
                     <div class="col-3 col-md-3 col-lg-1">
                        <UIRadioButton :label="$t('orderSearch_filter_lblOrderId')" name="rdoFlightOrderId" id="rdoFlightOrderId" native-value="1" v-model="subProduct" />
                     </div>
                     <div class="col-3 col-md-3 col-lg-1">
                        <UIRadioButton label="PNR" name="pnr" id="pnr" native-value="2" v-model="subProduct" />
                     </div>
                     <div class="col-3 col-md-3 col-lg-1">
                        <UIRadioButton :label="$t('orderSearch_filter_lblEticket')" name="rdoEticket" id="rdoEticket" native-value="3" v-model="subProduct" />
                     </div>
                     <div class="col-3 col-md-3 col-lg-1">
                        <UIRadioButton :label="$t('orderSearch_filter_lblSurname')" name="rdoSurname" id="rdoSurname" native-value="4" v-model="subProduct" />
                     </div>
                  </div>

                  <!-- HOTEL SEARCH -->
                  <div class="sub-page-row-wrapper row gy-3" v-if="product == 2">
                     <div class="col-3 col-md-3 col-lg-1">
                        <UIRadioButton :label="$t('orderSearch_filter_lblOrderId')" name="rdoHotelOrderId" id="rdoHotelOrderId" native-value="1" v-model="subProduct" />
                     </div>
                     <div class="col-3 col-md-3 col-lg-1">
                        <UIRadioButton :label="$t('orderSearch_filter_lblVoucher')" name="rdoVoucher" id="rdoVoucher" native-value="2" v-model="subProduct" />
                     </div>
                     <div class="col-3 col-md-3 col-lg-1">
                        <UIRadioButton :label="$t('orderSearch_filter_lblVoucherId')" name="rdoVoucherId" id="rdoVoucherId" native-value="3" v-model="subProduct" />
                     </div>
                     <div class="col-3 col-md-3 col-lg-1">
                        <UIRadioButton :label="$t('orderSearch_filter_lblSurname')" name="rdoHotelSurname" id="rdoHotelSurname" native-value="4" v-model="subProduct" />
                     </div>
                  </div>

                  <!-- TRANSFER SEARCH -->
                  <div class="sub-page-row-wrapper row gy-3" v-if="product == 3">
                     <div class="col-3 col-md-3 col-lg-1">
                        <UIRadioButton :label="$t('orderSearch_filter_lblOrderId')" name="rdoTransferOrderId" id="rdoTransferOrderId" native-value="1" v-model="subProduct" />
                     </div>
                     <div class="col-3 col-md-3 col-lg-1">
                        <UIRadioButton label="TNR" name="rdoTnr" id="rdoTnr" native-value="2" v-model="subProduct" />
                     </div>
                     <div class="col-3 col-md-3 col-lg-1">
                        <UIRadioButton :label="$t('orderSearch_filter_lblSurname')" name="rdoTransferSurname" id="rdoTransferSurname" native-value="3" v-model="subProduct" />
                     </div>
                  </div>

                  <!-- RENT A CAR SEARCH -->
                  <div class="sub-page-row-wrapper row gy-3" v-if="product == 4">
                     <div class="col-3 col-md-3 col-lg-1">
                        <UIRadioButton :label="$t('orderSearch_filter_lblOrderId')" name="rdoRentACarOrderId" id="rdoRentACarOrderId" native-value="1" v-model="subProduct" />
                     </div>
                     <div class="col-3 col-md-3 col-lg-1">
                        <UIRadioButton label="RNR" name="rdoRnr" id="rdoRnr" native-value="2" v-model="subProduct" />
                     </div>
                     <div class="col-3 col-md-3 col-lg-1">
                        <UIRadioButton :label="$t('orderSearch_filter_lblSurname')" name="rdoRentACarSurname" id="rdoRentACarSurname" native-value="3" v-model="subProduct" />
                     </div>
                  </div>

                  <!-- FLIGHT SEARCH BY SUBPRODUCT -->
                  <div class="sub-page-row-wrapper row gy-3" v-if="product == 1">
                     <!-- FLIGHT ORDER ID SEARCH -->
                     <KeepAlive>
                        <div class="col-12 col-md-6 col-lg-3" v-if="subProduct == 1">
                           <UIInput
                              :label="$t('orderSearch_filter_lblOrderId')"
                              v-model="searchQuery.flightOrderId"
                              :placeholder="$t('orderSearch_filter_plhOrderId')"
                              v-input="{ type: 'numeric', len: [3, 9], required: true, requiredMsg: $t('common_cannotBeEmpty') }"
                              id="flightOrderId" />
                        </div>
                     </KeepAlive>
                     <!-- FLIGHT PNR SEARCH -->
                     <KeepAlive>
                        <div class="col-12 col-md-6 col-lg-3" v-if="subProduct == 2">
                           <UIInput
                              :label="$t('orderSearch_filter_lblPnr')"
                              v-model="searchQuery.pnr"
                              :placeholder="$t('orderSearch_filter_plhPnr')"
                              v-input="{ type: 'alphanumeric', len: [3, 9], required: true, requiredMsg: $t('common_cannotBeEmpty') }"
                              id="pnr" />
                        </div>
                     </KeepAlive>
                     <!-- FLIGHT ETICKET SEARCH -->
                     <KeepAlive>
                        <div class="col-12 col-md-6 col-lg-3" v-if="subProduct == 3">
                           <UIInput
                              :label="$t('orderSearch_filter_lblEticket')"
                              v-model="searchQuery.eticket"
                              :placeholder="$t('orderSearch_filter_plhEticket')"
                              v-input="{ type: 'alphanumeric', len: [3, 20], required: true, requiredMsg: $t('common_cannotBeEmpty') }"
                              id="eticket" />
                        </div>
                     </KeepAlive>
                     <!-- FLIGHT LAST NAME SEARCH -->
                     <KeepAlive>
                        <div class="last-name-search-wrapper row">
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 4">
                              <UIDatePicker
                                 :label="$t('orderSearch_filter_lblCreationFromDate')"
                                 v-model="searchQuery.flightDate1.value"
                                 :min="searchQuery.flightDate1.min"
                                 :max="searchQuery.flightDate1.max"
                                 custom-header />
                           </div>
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 4">
                              <UIDatePicker
                                 :label="$t('orderSearch_filter_lblCreationToDate')"
                                 v-model="searchQuery.flightDate2.value"
                                 :min="searchQuery.flightDate2.min"
                                 :max="searchQuery.flightDate2.max"
                                 custom-header />
                           </div>
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 4">
                              <UISelectBox
                                 :key="$i18n.locale"
                                 :label="$t('orderSearch_filter_lblPnrStatus')"
                                 id="pnrStatus"
                                 :options="pnrStatuses"
                                 v-model="searchQuery.pnrStatus"
                                 :allow-search="true"
                                 light-theme />
                           </div>
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 4">
                              <UISelectBox
                                 :key="$i18n.locale"
                                 :label="$t('orderSearch_filter_lblProviderList')"
                                 id="flightProvidersList"
                                 :options="flightProviders"
                                 v-model="searchQuery.flightProviderId"
                                 :allow-search="true"
                                 light-theme />
                           </div>
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 4">
                              <UIInput
                                 :label="$t('orderSearch_filter_lblName')"
                                 :placeholder="$t('orderSearch_filter_plhName')"
                                 id="flightName"
                                 v-model="searchQuery.flightName"
                                 v-input="{ type: 'alphabetic', len: [0, 30], required: false, requiredMsg: $t('common_cannotBeEmpty') }" />
                           </div>
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 4">
                              <UIInput
                                 :label="$t('orderSearch_filter_lblSurname')"
                                 :placeholder="$t('orderSearch_filter_plhSurname')"
                                 id="flightSurname"
                                 v-model="searchQuery.flightSurname"
                                 v-input="{ type: 'alphabetic', len: [0, 30], required: false, requiredMsg: $t('common_cannotBeEmpty') }" />
                           </div>
                        </div>
                     </KeepAlive>
                  </div>

                  <!-- HOTEL SEARCH BY SUBPRODUCT -->
                  <div class="sub-page-row-wrapper row gy-3" v-if="product == 2">
                     <!-- HOTEL ORDER ID SEARCH -->
                     <KeepAlive>
                        <div class="col-12 col-md-6 col-lg-3" v-if="subProduct == 1">
                           <UIInput
                              :label="$t('orderSearch_filter_plhOrderId')"
                              v-model="searchQuery.hotelOrderId"
                              :placeholder="$t('orderSearch_filter_plhOrderId')"
                              id="hotelOrderId"
                              v-input="{ type: 'numeric', len: [3, 9], required: true, requiredMsg: $t('common_cannotBeEmpty') }" />
                        </div>
                     </KeepAlive>
                     <!-- HOTEL VOUCHER SEARCH -->
                     <KeepAlive>
                        <div class="col-12 col-md-6 col-lg-3" v-if="subProduct == 2">
                           <UIInput
                              :label="$t('orderSearch_filter_lblVoucher')"
                              v-model="searchQuery.voucher"
                              :placeholder="$t('orderSearch_filter_plhVoucher')"
                              id="voucher"
                              v-input="{ type: 'alphanumeric', len: [3, 14], required: true, requiredMsg: $t('common_cannotBeEmpty') }" />
                        </div>
                     </KeepAlive>
                     <!-- HOTEL VOUCHER ID SEARCH -->
                     <KeepAlive>
                        <div class="col-12 col-md-6 col-lg-3" v-if="subProduct == 3">
                           <UIInput
                              :label="$t('orderSearch_filter_lblVoucherId')"
                              v-model="searchQuery.voucherId"
                              :placeholder="$t('orderSearch_filter_plhVoucherId')"
                              id="voucherId"
                              v-input="{ type: 'numeric', len: [3, 14], required: true, requiredMsg: $t('common_cannotBeEmpty') }" />
                        </div>
                     </KeepAlive>
                     <!-- HOTEL LAST NAME SEARCH -->
                     <KeepAlive>
                        <div class="last-name-search-wrapper row">
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 4">
                              <UISelectBox :key="$i18n.locale" :label="$t('orderSearch_filter_lblDateType')" :options="hotelDateTypes" v-model="searchQuery.dateType" light-theme />
                           </div>
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 4">
                              <UIDatePicker
                                 :label="$t('orderSearch_filter_lblCreationFromDate')"
                                 v-model="searchQuery.hotelDate1.value"
                                 :min="searchQuery.hotelDate1.min"
                                 :max="searchQuery.hotelDate1.max"
                                 custom-header />
                           </div>
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 4">
                              <UIDatePicker
                                 :label="$t('orderSearch_filter_lblCreationToDate')"
                                 v-model="searchQuery.hotelDate2.value"
                                 :min="searchQuery.hotelDate2.min"
                                 :max="searchQuery.hotelDate2.max"
                                 custom-header />
                           </div>
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 4">
                              <UISelectBox
                                 :key="$i18n.locale"
                                 :label="$t('orderSearch_filter_lblVoucherStatus')"
                                 id="voucherStatus"
                                 :options="voucherStatuses"
                                 v-model="searchQuery.voucherStatus"
                                 :allow-search="true"
                                 light-theme />
                           </div>
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 4">
                              <UIInput
                                 :label="$t('orderSearch_filter_lblName')"
                                 :placeholder="$t('orderSearch_filter_plhName')"
                                 id="hotelName"
                                 v-model="searchQuery.hotelName"
                                 v-input="{ type: 'alphabetic', len: [0, 30], required: false, requiredMsg: $t('common_cannotBeEmpty') }" />
                           </div>
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 4">
                              <UIInput
                                 :label="$t('orderSearch_filter_lblSurname')"
                                 :placeholder="$t('orderSearch_filter_plhSurname')"
                                 id="hotelSurname"
                                 v-model="searchQuery.hotelSurname"
                                 v-input="{ type: 'alphabetic', len: [0, 30], required: false, requiredMsg: $t('common_cannotBeEmpty') }" />
                           </div>
                        </div>
                     </KeepAlive>
                  </div>

                  <!-- TRANSFER SEARCH BY SUBPRODUCT -->
                  <div class="sub-page-row-wrapper row gy-3" v-if="product == 3">
                     <!-- TRANSFER ORDER ID SEARCH -->
                     <KeepAlive>
                        <div class="col-12 col-md-6 col-lg-3" v-if="subProduct == 1">
                           <UIInput
                              :label="$t('orderSearch_filter_plhOrderId')"
                              v-model="searchQuery.transferOrderId"
                              :placeholder="$t('orderSearch_filter_plhOrderId')"
                              id="transferOrderId"
                              v-input="{ type: 'numeric', len: [3, 9], required: true, requiredMsg: $t('common_cannotBeEmpty') }" />
                        </div>
                     </KeepAlive>
                     <!-- TRANSFER VOUCHER SEARCH -->
                     <KeepAlive>
                        <div class="col-12 col-md-6 col-lg-3" v-if="subProduct == 2">
                           <UIInput
                              :label="$t('orderSearch_filter_lblTnr')"
                              v-model="searchQuery.tnr"
                              :placeholder="$t('orderSearch_filter_plhTnr')"
                              id="tnr"
                              v-input="{ type: 'alphanumeric', len: [3, 10], required: true, requiredMsg: $t('common_cannotBeEmpty') }" />
                        </div>
                     </KeepAlive>
                     <!-- TRANSFER LAST NAME SEARCH -->
                     <KeepAlive>
                        <div class="last-name-search-wrapper row">
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 3">
                              <UISelectBox :key="$i18n.locale" :label="$t('orderSearch_filter_lblDateType')" :options="transferDateTypes" v-model="searchQuery.transferDateType" light-theme />
                           </div>
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 3">
                              <UIDatePicker
                                 :label="$t('orderSearch_filter_lblCreationFromDate')"
                                 v-model="searchQuery.transferDate1.value"
                                 :min="searchQuery.transferDate1.min"
                                 :max="searchQuery.transferDate1.max"
                                 custom-header />
                           </div>
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 3">
                              <UIDatePicker
                                 :label="$t('orderSearch_filter_lblCreationToDate')"
                                 v-model="searchQuery.transferDate2.value"
                                 :min="searchQuery.transferDate2.min"
                                 :max="searchQuery.transferDate2.max"
                                 custom-header />
                           </div>
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 3">
                              <UISelectBox
                                 :key="$i18n.locale"
                                 :label="$t('orderSearch_filter_lblTnrStatus')"
                                 id="tnrStatus"
                                 :options="tnrStatuses"
                                 v-model="searchQuery.tnrStatus"
                                 :allow-search="true"
                                 light-theme />
                           </div>
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 3">
                              <UISelectBox
                                 :key="$i18n.locale"
                                 :label="$t('orderSearch_filter_lblProviderList')"
                                 id="transferProvider"
                                 :options="transferProviders"
                                 v-model="searchQuery.transferProviderId"
                                 :allow-search="true"
                                 light-theme />
                           </div>
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 3">
                              <UIInput
                                 :label="$t('orderSearch_filter_lblName')"
                                 :placeholder="$t('orderSearch_filter_plhName')"
                                 id="transferName"
                                 v-model="searchQuery.transferName"
                                 v-input="{ type: 'alphabetic', len: [0, 30], required: false, requiredMsg: $t('common_cannotBeEmpty') }" />
                           </div>
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 3">
                              <UIInput
                                 :label="$t('orderSearch_filter_lblSurname')"
                                 :placeholder="$t('orderSearch_filter_plhSurname')"
                                 id="transferSurname"
                                 v-model="searchQuery.transferSurname"
                                 v-input="{ type: 'alphabetic', len: [0, 30], required: false, requiredMsg: $t('common_cannotBeEmpty') }" />
                           </div>
                        </div>
                     </KeepAlive>
                  </div>
                  <!-- RENT A CAR SEARCH BY SUBPRODUCT -->
                  <div class="sub-page-row-wrapper row gy-3" v-if="product == 4">
                     <!-- RENT A CAR ORDER ID SEARCH -->
                     <KeepAlive>
                        <div class="col-12 col-md-6 col-lg-3" v-if="subProduct == 1">
                           <UIInput
                              :label="$t('orderSearch_filter_plhOrderId')"
                              v-model="searchQuery.rentACarOrderId"
                              :placeholder="$t('orderSearch_filter_plhOrderId')"
                              id="rentACarOrderId"
                              v-input="{ type: 'numeric', len: [3, 9], required: true, requiredMsg: $t('common_cannotBeEmpty') }" />
                        </div>
                     </KeepAlive>
                     <!-- RENT A CAR RNR SEARCH -->
                     <KeepAlive>
                        <div class="col-12 col-md-6 col-lg-3" v-if="subProduct == 2">
                           <UIInput
                              :label="$t('orderSearch_filter_lblRnr')"
                              v-model="searchQuery.rnr"
                              :placeholder="$t('orderSearch_filter_plhRnr')"
                              id="rnr"
                              v-input="{ type: 'alphanumeric', len: [3, 10], required: true, requiredMsg: $t('common_cannotBeEmpty') }" />
                        </div>
                     </KeepAlive>
                     <!-- RENT A CAR LAST NAME SEARCH -->
                     <KeepAlive>
                        <div class="last-name-search-wrapper row">
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 3">
                              <UISelectBox :key="$i18n.locale" :label="$t('orderSearch_filter_lblDateType')" :options="rentACarDateTypes" v-model="searchQuery.rentACarDateType" light-theme />
                           </div>
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 3">
                              <UIDatePicker
                                 :label="$t('orderSearch_filter_lblCreationFromDate')"
                                 v-model="searchQuery.rentACarDate1.value"
                                 :min="searchQuery.rentACarDate1.min"
                                 :max="searchQuery.rentACarDate1.max"
                                 custom-header />
                           </div>
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 3">
                              <UIDatePicker
                                 :label="$t('orderSearch_filter_lblCreationToDate')"
                                 v-model="searchQuery.rentACarDate2.value"
                                 :min="searchQuery.rentACarDate2.min"
                                 :max="searchQuery.rentACarDate2.max"
                                 custom-header />
                           </div>
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 3">
                              <UISelectBox
                                 :key="$i18n.locale"
                                 :label="$t('orderSearch_filter_lblRnrStatus')"
                                 id="rnrStatus"
                                 :options="rnrStatuses"
                                 v-model="searchQuery.rnrStatus"
                                 :allow-search="true"
                                 light-theme />
                           </div>
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 3">
                              <UIInput
                                 :label="$t('orderSearch_filter_lblName')"
                                 :placeholder="$t('orderSearch_filter_plhName')"
                                 id="rentACarName"
                                 v-model="searchQuery.rentACarName"
                                 v-input="{ type: 'alphabetic', len: [0, 30], required: false, requiredMsg: $t('common_cannotBeEmpty') }" />
                           </div>
                           <div class="col-12 col-md-6 col-lg" v-if="subProduct == 3">
                              <UIInput
                                 :label="$t('orderSearch_filter_lblSurname')"
                                 :placeholder="$t('orderSearch_filter_plhSurname')"
                                 id="rentACarSurname"
                                 v-model="searchQuery.rentACarSurname"
                                 v-input="{ type: 'alphabetic', len: [0, 30], required: false, requiredMsg: $t('common_cannotBeEmpty') }" />
                           </div>
                        </div>
                     </KeepAlive>
                  </div>
                  <div class="sub-page-actions-row row">
                     <div class="sub-pages-actions-wrapper col-12">
                        <UIButton className="default" :text="$t('common_search')" @click.native="handlerOrderSearch" />
                     </div>
                  </div>
               </div>
            </div>
            <div class="gts-grid-container">
               <template v-if="currentTableOptions.rows.length > 0">
                  <section class="page-section">
                     <div class="page-section-inner gts-box">
                        <GtsGrid :table-options="currentTableOptions" :item-per-page="-1" :title="$t('orderSearch_pageTitle')" />
                     </div>
                  </section>
               </template>
            </div>
         </div>
      </Main>
   </div>
</template>

<script>
import moment from "moment";
import Popup from "@/gts-popup.js";
import Main from "@/components/unitary/Main.vue";
import Aside from "@/components/unitary/Aside.vue";
import GtsGrid from "@/components/utils/GtsGrid.vue";
import Navbar from "@/components/unitary/Navbar.vue";
import UIButton from "@/components/unitary/Button.vue";
import UIInput from "@/components/unitary/form2/UIInput.vue";
import { orderService, agencyService } from "@/service/index.js";
import UISelectBox from "@/components/unitary/form2/UISelectBox.vue";
import UIRadioButton from "@/components/unitary/form2/UIRadioButton.vue";
import UIDatePicker from "@/components/unitary/form2/UIDatePicker2.vue";

export default {
   name: "OrderSearch",
   components: {
      Main,
      Aside,
      Navbar,
      GtsGrid,
      UIInput,
      UIButton,
      UISelectBox,
      UIRadioButton,
      UIDatePicker,
   },
   data() {
      return {
         searchQuery: {
            // flight related search fields
            flightOrderId: null,
            pnr: null,
            eticket: null,
            flightName: null,
            flightSurname: null,
            flightProviderId: -1,
            pnrStatus: -1,
            flightDate1: {
               min: moment().subtract(1, "year").set("month", 0).set("date", 1).format(this.$constants.dateFormat),
               max: moment().format(this.$constants.dateFormat),
               value: moment().subtract(1, "year").format(this.$constants.dateFormat),
            },
            flightDate2: {
               min: moment().subtract(1, "year").format(this.$constants.dateFormat),
               max: moment().format(this.$constants.dateFormat),
               value: moment().format(this.$constants.dateFormat),
            },
            // hotel related search fields
            hotelOrderId: null,
            voucher: null,
            voucherId: null,
            hotelName: null,
            hotelSurname: null,
            hotelDateType: 1,
            voucherStatus: -1,
            hotelDate1: {
               min: moment().subtract(1, "year").format(this.$constants.dateFormat),
               max: moment().format(this.$constants.dateFormat),
               value: moment().format(this.$constants.dateFormat),
            },
            hotelDate2: {
               min: moment().subtract(1, "year").format(this.$constants.dateFormat),
               max: moment().format(this.$constants.dateFormat),
               value: moment().format(this.$constants.dateFormat),
            },
            // transfer related search fields
            transferOrderId: -1,
            tnr: null,
            transferName: null,
            transferSurname: null,
            transferProviderId: -1,
            tnrStatus: -1,
            transferDateType: 1,
            transferFromLocation: -1,
            transferToLocation: -1,
            transferDate1: {
               min: moment().subtract(2, "years").format(this.$constants.dateFormat),
               max: moment().format(this.$constants.dateFormat),
               value: moment().format(this.$constants.dateFormat),
            },
            transferDate2: {
               min: moment().subtract(2, "years").format(this.$constants.dateFormat),
               max: moment().format(this.$constants.dateFormat),
               value: moment().format(this.$constants.dateFormat),
            },
            // rent a car related search fields
            rentACarOrderId: null,
            rnr: null,
            rentACarName: null,
            rentACarSurname: null,
            rentACarProviderId: -1,
            rnrStatus: -1,
            rentACarDateType: 1,
            rentACarPickUpLocationId: -1,
            rentACarDropOffLocationId: -1,
            rentACarDate1: {
               min: moment().subtract(2, "years").format(this.$constants.dateFormat),
               max: moment().format(this.$constants.dateFormat),
               value: moment().format(this.$constants.dateFormat),
            },
            rentACarDate2: {
               min: moment().subtract(2, "years").format(this.$constants.dateFormat),
               max: moment().format(this.$constants.dateFormat),
               value: moment().format(this.$constants.dateFormat),
            },
         },
         product: 1,
         subProduct: 2,
         flightTableOptions: {
            columns: [],
            rows: [],
         },
         hotelTableOptions: {
            columns: [],
            rows: [],
         },
         transferTableOptions: {
            columns: [],
            rows: [],
         },
         rentACarTableOptions: {
            columns: [],
            rows: [],
         },
         initialFlightProviders: [],
         initialTransferProviders: [],
      };
   },
   created() {
      agencyService.listProviders({ type: 1 }).then((res) => {
         this.initialFlightProviders = res.providers;
      });
      agencyService.listProviders({ type: 3 }).then((res) => {
         this.initialTransferProviders = res.providers;
      });
   },
   computed: {
      pnrStatuses() {
         return this.$GtsDropdownData.EFltPnrStatus(true, false, [10, 11, 12, 13, 14]);
      },
      hotelDateTypes() {
         return this.$GtsDropdownData.EOdrSearchHotelDateType();
      },
      voucherStatuses() {
         return this.$GtsDropdownData.EHtlVoucherStatus(true, false, [10, 11, 12, 13, 14]);
      },
      tnrStatuses() {
         return this.$GtsDropdownData.ETrfTnrStatus(true);
      },
      rnrStatuses() {
         return this.$GtsDropdownData.ERacRnrStatus(true);
      },
      transferDateTypes() {
         return this.$GtsDropdownData.EReportTransferDateType();
      },
      rentACarDateTypes() {
         return this.$GtsDropdownData.EOdrSearchRentACarDateType();
      },
      flightTableColumns() {
         return [
            { label: this.$t("orderSearch_tblMain_orderId"), field: "orderId" },
            { label: this.$t("orderSearch_tblMain_gsaName"), field: "gsaName" },
            { label: this.$t("orderSearch_tblMain_agencyName"), field: "agencyName" },
            { label: this.$t("orderSearch_tblMain_pnrStatuses"), field: "pnrStatuses" },
            { label: this.$t("orderSearch_tblMain_pnrs"), field: "pnrs" },
            { label: this.$t("orderSearch_tblMain_etickets"), field: "etickets" },
            { label: this.$t("orderSearch_tblMain_nameSurname"), field: "nameSurname" },
            { label: this.$t("orderSearch_tblMain_insertedUser"), field: "insertedUser" },
            { label: this.$t("orderSearch_tblMain_insertedDate"), field: "insertedDate" },
         ];
      },
      hotelTableColumns() {
         return [
            { label: this.$t("orderSearch_tblMain_orderId"), field: "orderId" },
            { label: this.$t("orderSearch_tblMain_gsaName"), field: "gsaName" },
            { label: this.$t("orderSearch_tblMain_agencyName"), field: "agencyName" },
            { label: this.$t("orderSearch_tblMain_voucherStatuses"), field: "voucherStatuses" },
            { label: this.$t("orderSearch_tblMain_vouchers"), field: "vouchers" },
            { label: this.$t("orderSearch_tblMain_voucherId"), field: "voucherId" },
            { label: this.$t("orderSearch_tblMain_rooms"), field: "rooms" },
            { label: this.$t("orderSearch_tblMain_nameSurname"), field: "nameSurname" },
            { label: this.$t("orderSearch_tblMain_insertedUser"), field: "insertedUser" },
            { label: this.$t("orderSearch_tblMain_insertedDate"), field: "insertedDate" },
         ];
      },
      transferTableColumns() {
         return [
            { label: this.$t("orderSearch_tblMain_orderId"), field: "orderId" },
            { label: this.$t("orderSearch_tblMain_gsaName"), field: "gsaName" },
            { label: this.$t("orderSearch_tblMain_agencyName"), field: "agencyName" },
            { label: this.$t("orderSearch_tblMain_tnrStatuses"), field: "tnrStatuses" },
            { label: this.$t("orderSearch_tblMain_tnrs"), field: "tnrs" },
            { label: this.$t("orderSearch_tblMain_nameSurname"), field: "nameSurname" },
            { label: this.$t("orderSearch_tblMain_insertedUser"), field: "insertedUser" },
            { label: this.$t("orderSearch_tblMain_insertedDate"), field: "insertedDate" },
         ];
      },
      rentACarTableColumns() {
         return [
            { label: this.$t("orderSearch_tblMain_orderId"), field: "orderId" },
            { label: this.$t("orderSearch_tblMain_gsaName"), field: "gsaName" },
            { label: this.$t("orderSearch_tblMain_agencyName"), field: "agencyName" },
            { label: this.$t("orderSearch_tblMain_vehicle"), field: "vehicle" },
            { label: this.$t("orderSearch_tblMain_pickUpDateTime"), field: "pickUpDateTime" },
            { label: this.$t("orderSearch_tblMain_rnrStatus"), field: "rnrStatus" },
            { label: this.$t("orderSearch_tblMain_rnr"), field: "rnr" },
            { label: this.$t("orderSearch_tblMain_pickUpLocation"), field: "pickUpLocation" },
            { label: this.$t("orderSearch_tblMain_dropOffLocation"), field: "dropOffLocation" },
            { label: this.$t("orderSearch_tblMain_nameSurname"), field: "nameSurname" },
            { label: this.$t("orderSearch_tblMain_insertedUser"), field: "insertedUser" },
            { label: this.$t("orderSearch_tblMain_insertedDate"), field: "insertedDate" },
         ];
      },
      currentTableOptions() {
         switch (Number(this.product)) {
            case 1:
               return { ...this.flightTableOptions, columns: this.flightTableColumns };
            case 2:
               return { ...this.hotelTableOptions, columns: this.hotelTableColumns };
            case 3:
               return { ...this.transferTableOptions, columns: this.transferTableColumns };
            case 4:
               return { ...this.rentACarTableOptions, columns: this.rentACarTableColumns };
            default:
               return { columns: [], rows: [] };
         }
      },
      flightProviders() {
         return [
            { value: -1, name: this.$options.filters.EFltPnrStatus(-1) },
            ...this.initialFlightProviders.map((provider) => ({
               value: provider.id,
               name: provider.name,
            })),
         ];
      },
      transferProviders() {
         return [
            { value: -1, name: this.$options.filters.ETrfTnrStatus(-1) },
            ...this.initialTransferProviders.map((provider) => ({
               value: provider.id,
               name: provider.name,
            })),
         ];
      },
   },
   methods: {
      handlerOrderSearch() {
         this.flightTableOptions.rows = [];
         this.hotelTableOptions.rows = [];
         this.transferTableOptions.rows = [];
         this.rentACarTableOptions.rows = [];

         switch (Number(this.product)) {
            case 1:
               this.handlerSearchFlight();
               break;
            case 2:
               this.handlerSearchHotel();
               break;
            case 3:
               this.handlerSearchTransfer();
               break;
            case 4:
               this.handlerSearchRentACar();
               break;
            default:
               console.warn("Invalid product value:", this.product);
         }
      },
      handlerSearchFlight() {
         const query = {};

         this.$validate().then((res) => {
            if (res.success) {
               if (this.subProduct == 1) {
                  // ORDER ID
                  query.orderId = this.searchQuery.flightOrderId;
               } else if (this.subProduct == 2) {
                  // PNR
                  query.pnr = this.searchQuery.pnr == "" ? null : this.searchQuery.pnr;
               } else if (this.subProduct == 3) {
                  // E TICKET
                  query.eticket = this.searchQuery.eticket == "" ? null : this.searchQuery.eticket;
               } else if (this.subProduct == 4) {
                  // SURNAME
                  if (this.searchQuery.flightSurname?.length == 0 && this.searchQuery.flightName?.length == 0) {
                     query.date1 = moment().format(this.$constants.dateFormat);
                     query.date2 = moment().format(this.$constants.dateFormat);
                     query.pnrStatus = this.searchQuery.pnrStatus;
                     query.providerId = this.searchQuery.flightProviderId;
                     query.surname = null;
                     query.name = null;
                     this.searchQuery.flightDate1.value = moment().format(this.$constants.dateFormat);
                     this.searchQuery.flightDate2.value = moment().format(this.$constants.dateFormat);
                  } else if (this.searchQuery.flightSurname?.length >= 2 || this.searchQuery.flightName?.length >= 2) {
                     if (this.searchQuery.flightSurname?.length < 2 && this.searchQuery.flightSurname?.length != 0) {
                        Popup.warning(this.$i18n.t("Popup_lblLessThanTwoCharacter"), this.$i18n.t("Popup_txtLessThanTwoCharacter"));
                        return;
                     }
                     if (this.searchQuery.flightName?.length < 2 && this.searchQuery.flightName?.length != 0) {
                        Popup.warning(this.$i18n.t("Popup_lblLessThanTwoCharacter"), this.$i18n.t("Popup_txtLessThanTwoCharacter"));
                        return;
                     }
                     query.date1 = this.searchQuery.flightDate1.value;
                     query.date2 = this.searchQuery.flightDate2.value;
                     query.pnrStatus = this.searchQuery.pnrStatus;
                     query.providerId = this.searchQuery.flightProviderId;
                     query.surname = this.searchQuery.flightSurname.length >= 2 ? this.searchQuery.flightSurname : null;
                     query.name = this.searchQuery.flightName.length >= 2 ? this.searchQuery.flightName : null;
                  } else {
                     Popup.warning(this.$i18n.t("Popup_lblLessThanTwoCharacter"), this.$i18n.t("Popup_txtLessThanTwoCharacter"));
                  }
               }

               this.$store.commit("app/setIsProgressGifActive", true);
               orderService.searchOrderFlight(query).then((res) => {
                  if (res.result.success) {
                     res.orders.map((orderItem) => {
                        const orderRowObj = {
                           order: {
                              iteration: [orderItem.orderId],
                              className: "order-router gts-animation-scale",
                              router: `/order/detail/${orderItem.orderUuid}`,
                           },
                           gsaName: orderItem.gsaName,
                           agencyName: orderItem.agencyName,
                           pnrStatuses: {
                              iteration: orderItem.pnrStatuses,
                              className: "badge",
                              filter: "EFltPnrStatus",
                           },
                           pnrs: {
                              iteration: orderItem.pnrs,
                           },
                           etickets: {
                              iteration: orderItem.etickets,
                           },
                           nameSurname: orderItem.nameSurname,
                           insertedUser: orderItem.insertedUserEmail,
                           insertedDate: moment(orderItem.insertedDateTime).format("DD.MM.YYYY"),
                           tags: JSON.stringify(orderItem),
                        };

                        this.flightTableOptions.rows.push(orderRowObj);
                     });
                     this.flightTableOptions.rows.reverse();
                     this.$store.commit("app/setIsProgressGifActive", false);
                  }
               });
            }
         });
      },
      handlerSearchHotel() {
         const query = {};

         this.$validate().then((res) => {
            if (res.success) {
               if (this.subProduct == 1) {
                  // ORDER ID
                  query.orderId = this.searchQuery.hotelOrderId;
               } else if (this.subProduct == 2) {
                  // VOUCHER
                  query.voucher = this.searchQuery.voucher == "" ? null : this.searchQuery.voucher;
               } else if (this.subProduct == 3) {
                  // VOUCHER ID
                  query.voucherId = this.searchQuery.voucherId;
               } else if (this.subProduct == 4) {
                  // SURNAME
                  if (this.searchQuery.hotelName?.length == 0 && this.searchQuery.hotelSurname?.length == 0) {
                     query.dateType = this.searchQuery.hotelDateType;
                     query.date1 = this.searchQuery.hotelDate1.value;
                     query.date2 = this.searchQuery.hotelDate2.value;
                     query.voucherStatus = this.searchQuery.voucherStatus;
                     query.providerId = -1; //Provider filter disabled so passing -1
                     query.surname = null;
                     query.name = null;
                  } else if (this.searchQuery.hotelSurname?.length >= 2 || this.searchQuery.hotelName?.length >= 2) {
                     if (this.searchQuery.hotelSurname?.length < 2 && this.searchQuery.hotelSurname?.length != 0) {
                        Popup.warning(this.$i18n.t("Popup_lblLessThanTwoCharacter"), this.$i18n.t("Popup_txtLessThanTwoCharacter"));
                        return;
                     }
                     if (this.searchQuery.hotelName?.length < 2 && this.searchQuery.hotelName?.length != 0) {
                        Popup.warning(this.$i18n.t("Popup_lblLessThanTwoCharacter"), this.$i18n.t("Popup_txtLessThanTwoCharacter"));
                        return;
                     }
                     query.dateType = this.searchQuery.hotelDateType;
                     query.date1 = this.searchQuery.hotelDate1.value;
                     query.date2 = this.searchQuery.hotelDate2.value;
                     query.voucherStatus = this.searchQuery.voucherStatus;
                     query.providerId = -1; //Provider filter disabled so passing -1
                     query.surname = this.searchQuery.hotelSurname.length == 0 ? null : this.searchQuery.hotelSurname;
                     query.name = this.searchQuery.hotelName.length == 0 ? null : this.searchQuery.hotelName;
                  } else {
                     Popup.warning(this.$i18n.t("Popup_lblLessThanTwoCharacter"), this.$i18n.t("Popup_txtLessThanTwoCharacter"));
                  }
               }

               query.hotelId = -1;

               this.$store.commit("app/setIsProgressGifActive", true);
               orderService.searchOrderHotel(query).then((res) => {
                  if (res.result.success) {
                     res.orders.map((orderItem) => {
                        const orderRowObj = {
                           order: {
                              iteration: [orderItem.orderId],
                              className: "order-router gts-animation-scale",
                              router: `/order/detail/${orderItem.orderUuid}`,
                           },
                           gsaName: orderItem.gsaName,
                           agencyName: orderItem.agencyName,
                           voucherStatuses: {
                              iteration: orderItem.voucherStatuses,
                              className: "badge",
                              filter: "EHtlVoucherStatus",
                           },
                           vouchers: {
                              iteration: orderItem.vouchers,
                           },
                           voucherId: {
                              iteration: Object.keys(orderItem.vouchers).map((key) => Number(key)),
                           },
                           rooms: {
                              iteration: orderItem.rooms,
                           },
                           nameSurname: orderItem.nameSurname,
                           insertedUser: orderItem.insertedUserEmail,
                           insertedDate: moment(orderItem.insertedDateTime).format("DD.MM.YYYY"),
                           tags: JSON.stringify(orderItem),
                        };

                        this.hotelTableOptions.rows.reverse();
                        this.hotelTableOptions.rows.push(orderRowObj);
                     });
                     this.$store.commit("app/setIsProgressGifActive", false);
                  }
               });
            }
         });
      },
      handlerSearchTransfer() {
         const query = {};

         this.$validate().then((res) => {
            if (res.success) {
               if (this.subProduct == 1) {
                  // ORDER ID
                  query.orderId = this.searchQuery.transferOrderId;
               } else if (this.subProduct == 2) {
                  // TNR
                  query.tnr = this.searchQuery.tnr == "" ? null : this.searchQuery.tnr;
               } else if (this.subProduct == 3) {
                  // SURNAME
                  if (this.searchQuery.transferName?.length == 0 && this.searchQuery.transferSurname?.length == 0) {
                     query.dateType = this.searchQuery.transferDateType;
                     query.date1 = this.searchQuery.transferDate1.value;
                     query.date2 = this.searchQuery.transferDate2.value;
                     query.tnrStatus = this.searchQuery.tnrStatus;
                     query.providerId = this.searchQuery.transferProviderId;
                     query.fromLocationId = this.searchQuery.transferFromLocation;
                     query.toLocationId = this.searchQuery.transferToLocation;
                     query.surname = null;
                     query.name = null;
                     query.orderId = -1;
                     query.tnr = null;
                  } else if (this.searchQuery.transferName?.length >= 2 || this.searchQuery.transferSurname?.length >= 2) {
                     if (this.searchQuery.transferName?.length < 2 && this.searchQuery.transferName?.length != 0) {
                        Popup.warning(this.$i18n.t("Popup_lblLessThanTwoCharacter"), this.$i18n.t("Popup_txtLessThanTwoCharacter"));
                        return;
                     }
                     if (this.searchQuery.transferSurname?.length < 2 && this.searchQuery.transferSurname?.length != 0) {
                        Popup.warning(this.$i18n.t("Popup_lblLessThanTwoCharacter"), this.$i18n.t("Popup_txtLessThanTwoCharacter"));
                        return;
                     }
                     query.dateType = this.searchQuery.transferDateType;
                     query.date1 = this.searchQuery.transferDate1.value;
                     query.date2 = this.searchQuery.transferDate2.value;
                     query.tnrStatus = this.searchQuery.tnrStatus;
                     query.providerId = this.searchQuery.transferProviderId;
                     query.fromLocationId = this.searchQuery.transferFromLocation;
                     query.toLocationId = this.searchQuery.transferToLocation;
                     query.surname = this.searchQuery.transferSurname.length == 0 ? null : this.searchQuery.transferSurname;
                     query.name = this.searchQuery.transferName.length == 0 ? null : this.searchQuery.transferName;
                     query.orderId = -1;
                     query.tnr = null;
                  } else {
                     Popup.warning(this.$i18n.t("Popup_lblLessThanTwoCharacter"), this.$i18n.t("Popup_txtLessThanTwoCharacter"));
                  }
               }

               this.$store.commit("app/setIsProgressGifActive", true);
               orderService.searchOrderTransfer(query).then((res) => {
                  if (res.result.success) {
                     res.orders.map((orderItem) => {
                        const orderRowObj = {
                           order: {
                              iteration: [orderItem.orderId],
                              className: "order-router gts-animation-scale",
                              router: `/order/detail/${orderItem.orderUuid}`,
                           },
                           gsaName: orderItem.gsaName,
                           agencyName: orderItem.agencyName,
                           tnrStatuses: {
                              iteration: orderItem.tnrStatuses,
                              className: "badge",
                              filter: "ETrfTnrStatus",
                           },
                           tnrs: {
                              iteration: orderItem.tnrs,
                           },
                           nameSurname: orderItem.nameSurname,
                           insertedUser: orderItem.processUserEmail,
                           insertedDate: moment(orderItem.processDateTime).format("DD.MM.YYYY"),
                           tags: JSON.stringify(orderItem),
                        };

                        this.transferTableOptions.rows.reverse();
                        this.transferTableOptions.rows.push(orderRowObj);
                     });
                     this.$store.commit("app/setIsProgressGifActive", false);
                  }
               });
            }
         });
      },
      handlerSearchRentACar() {
         const query = {};

         this.$validate().then((res) => {
            if (res.success) {
               if (this.subProduct == 1) {
                  // ORDER ID
                  query.orderId = this.searchQuery.rentACarOrderId;
               } else if (this.subProduct == 2) {
                  // RNR
                  query.rnr = this.searchQuery.rnr == "" ? null : this.searchQuery.rnr;
               } else if (this.subProduct == 3) {
                  // SURNAME
                  if (this.searchQuery.rentACarName?.length == 0 && this.searchQuery.rentACarSurname?.length == 0) {
                     query.dateType = this.searchQuery.rentACarDateType;
                     query.date1 = this.searchQuery.rentACarDate1.value;
                     query.date2 = this.searchQuery.rentACarDate2.value;
                     query.rnrStatus = this.searchQuery.rnrStatus;
                     query.providerId = this.searchQuery.rentACarProviderId;
                     query.pickUpLocationId = this.searchQuery.rentACarPickUpLocationId;
                     query.dropOffLocationId = this.searchQuery.rentACarDropOffLocationId;
                     query.surname = null;
                     query.name = null;
                     query.orderId = -1;
                     query.rnr = null;
                  } else if (this.searchQuery.rentACarName?.length >= 2 || this.searchQuery.rentACarSurname?.length >= 2) {
                     if (this.searchQuery.rentACarName?.length < 2 && this.searchQuery.rentACarName?.length != 0) {
                        Popup.warning(this.$i18n.t("Popup_lblLessThanTwoCharacter"), this.$i18n.t("Popup_txtLessThanTwoCharacter"));
                        return;
                     }
                     if (this.searchQuery.rentACarSurname?.length < 2 && this.searchQuery.rentACarSurname?.length != 0) {
                        Popup.warning(this.$i18n.t("Popup_lblLessThanTwoCharacter"), this.$i18n.t("Popup_txtLessThanTwoCharacter"));
                        return;
                     }
                     query.dateType = this.searchQuery.rentACarDateType;
                     query.date1 = this.searchQuery.rentACarDate1.value;
                     query.date2 = this.searchQuery.rentACarDate2.value;
                     query.rnrStatus = this.searchQuery.rnrStatus;
                     query.providerId = this.searchQuery.rentACarProviderId;
                     query.pickUpLocationId = this.searchQuery.rentACarPickUpLocationId;
                     query.dropOffLocationId = this.searchQuery.rentACarDropOffLocationId;
                     query.surname = this.searchQuery.rentACarSurname.length == 0 ? null : this.searchQuery.rentACarSurname;
                     query.name = this.searchQuery.rentACarName.length == 0 ? null : this.searchQuery.rentACarName;
                     query.orderId = -1;
                     query.rnr = null;
                  } else {
                     Popup.warning(this.$i18n.t("Popup_lblLessThanTwoCharacter"), this.$i18n.t("Popup_txtLessThanTwoCharacter"));
                  }
               }

               this.$store.commit("app/setIsProgressGifActive", true);
               orderService.searchOrderRentACar(query).then((res) => {
                  if (res.result.success) {
                     res.orders.map((orderItem) => {
                        const orderRowObj = {
                           order: {
                              iteration: [orderItem.orderId],
                              className: "order-router gts-animation-scale",
                              router: `/order/detail/${orderItem.orderUuid}`,
                           },
                           gsaName: orderItem.gsaName,
                           agencyName: orderItem.agencyName,
                           vehicle: orderItem.vehicle,
                           pickupDateTime: moment(orderItem.pickupDateTime).format("DD.MM.YYYY"),
                           rnrStatus: {
                              iteration: [orderItem.rnrStatus],
                              className: "badge",
                              filter: "ERacRnrStatus",
                           },
                           rnr: {
                              iteration: [orderItem.rnr],
                           },
                           pickUpLocation: orderItem.pickUpLocation,
                           dropOffLocation: orderItem.dropOffLocation,
                           nameSurname: orderItem.nameSurname,
                           insertedUser: orderItem.processUserEmail,
                           insertedDate: moment(orderItem.processDateTime).format("DD.MM.YYYY"),
                           tags: JSON.stringify(orderItem),
                        };

                        this.rentACarTableOptions.rows.reverse();
                        this.rentACarTableOptions.rows.push(orderRowObj);
                     });
                     this.$store.commit("app/setIsProgressGifActive", false);
                  }
               });
            }
         });
      },
   },
   watch: {
      product: {
         handler: function () {
            this.subProduct = 2;
         },
      },
      "searchQuery.hotelDateType": {
         handler: function (hotelDateType) {
            if (hotelDateType == 1) {
               // PROCESS
               this.searchQuery.hotelDate1.max = moment().format(this.$constants.dateFormat);
               this.searchQuery.hotelDate2.max = moment().format(this.$constants.dateFormat);
            } else if (hotelDateType == 2) {
               // CHECKIN
               this.searchQuery.hotelDate1.max = moment().add(2, "years").format(this.$constants.dateFormat);
               this.searchQuery.hotelDate2.max = moment().add(2, "years").format(this.$constants.dateFormat);
            }
         },
      },
      "searchQuery.transferDateType": {
         handler: function (transferDateType) {
            if (transferDateType == 1) {
               // SALE
               this.searchQuery.transferDate1.min = moment().subtract(2, "years").format(this.$constants.dateFormat);
               this.searchQuery.transferDate1.max = moment().format(this.$constants.dateFormat);
               this.searchQuery.transferDate2.min = moment().subtract(2, "years").format(this.$constants.dateFormat);
               this.searchQuery.transferDate2.max = moment().format(this.$constants.dateFormat);
            } else if (transferDateType == 2) {
               // TRANSFER
               this.searchQuery.transferDate1.min = moment().subtract(2, "years").format(this.$constants.dateFormat);
               this.searchQuery.transferDate1.max = moment().add(2, "years").format(this.$constants.dateFormat);
               this.searchQuery.transferDate2.min = moment().subtract(2, "years").format(this.$constants.dateFormat);
               this.searchQuery.transferDate2.max = moment().add(2, "years").format(this.$constants.dateFormat);
            }
         },
      },
      "searchQuery.rentACarDateType": {
         handler: function (rentACarDateType) {
            if (rentACarDateType == 1) {
               // PROCESS
               this.searchQuery.rentACarDate1.min = moment().subtract(1, "years").format(this.$constants.dateFormat);
               this.searchQuery.rentACarDate1.max = moment().format(this.$constants.dateFormat);
               this.searchQuery.rentACarDate2.min = moment().subtract(1, "years").format(this.$constants.dateFormat);
               this.searchQuery.rentACarDate2.max = moment().format(this.$constants.dateFormat);
            } else if (rentACarDateType == 2) {
               // PICK UP
               this.searchQuery.rentACarDate1.min = moment().subtract(1, "years").format(this.$constants.dateFormat);
               this.searchQuery.rentACarDate1.max = moment().add(1, "years").format(this.$constants.dateFormat);
               this.searchQuery.rentACarDate2.min = moment().subtract(1, "years").format(this.$constants.dateFormat);
               this.searchQuery.rentACarDate2.max = moment().add(1, "years").format(this.$constants.dateFormat);
            }
         },
      },
   },
};
</script>

<style lang="scss" scoped>
.order-page-wrapper {
   .order-page-inner {
      // width: 90%;
      margin: auto;

      .page-subheader-navigate-wrapper {
         .page-subheader-navigate-inner {
            .ps-product-subtype-forms {
               display: grid;
               grid-template-columns: repeat(5, 2fr);
               grid-column-gap: 1.5rem;
            }

            .ps-action-wrapper {
               display: flex;
               justify-content: flex-end;
               margin-top: 1.5rem;
            }
         }
      }

      ::v-deep {
         .vgt-left-align {
            text-align: left !important;
         }
         .dataTable-order-search-multi-row {
            display: flex;
            flex-direction: column;
            span {
               margin-bottom: 0.5rem;

               &:last-child {
                  margin: 0;
               }
            }
         }
      }
   }
}

.last-name-search-wrapper {
   margin-top: 1rem;
}

.ps-form-row {
   display: grid;
   grid-template-columns: repeat(4, 150px);
   margin-bottom: 1rem;

   > div {
      margin-right: 1rem;
   }
}
</style>
